import { FileInput } from 'foundations-components/transitional/components/FileInput';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { useContext } from 'react';
import { matchPropertyTypeToInput, propertyFieldTypes } from '../../../constants/properties';
import { AppContext } from '../../../contexts/app/context';
import InputWithDropdown from '../InputWithDropdown/InputWithDropdown';
import FormDateInput from './FormDateInput';
import UIInputWrapper from './UIInputWrapper/UIInputWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const FormInput = ({
  property,
  onChange,
  currentValue,
  editMode = false,
  disabled = false,
  inputRef,
  objectType,
  correlatedField,
  correlatedFieldValue,
  autoFocus,
  hubspotUserId,
  prosemirrorEditor
}) => {
  const {
    appName
  } = useContext(AppContext);
  switch (property.fieldType) {
    case propertyFieldTypes.html:
      return prosemirrorEditor;
    case propertyFieldTypes.select:
    case propertyFieldTypes.radio:
    case propertyFieldTypes.booleancheckbox:
    case propertyFieldTypes.checkbox:
      return /*#__PURE__*/_jsx(InputWithDropdown, {
        onFormValueChanged: onChange,
        property: property,
        currentValue: currentValue,
        editMode: editMode,
        disabled: disabled,
        appName: appName,
        objectType: objectType,
        correlatedField: correlatedField,
        correlatedFieldValue: correlatedFieldValue,
        defaultOpen: autoFocus,
        hubspotUserId: hubspotUserId
      });
    case propertyFieldTypes.date:
      return /*#__PURE__*/_jsx(FormDateInput, {
        property: property,
        onChange: onChange,
        currentValue: currentValue,
        editMode: editMode,
        disabled: disabled,
        defaultOpen: autoFocus
      });
    case propertyFieldTypes.file:
      return /*#__PURE__*/_jsx(UIInputWrapper, {
        property: property,
        editMode: editMode,
        ariaLabel: "form-file-input",
        children: /*#__PURE__*/_jsx(FileInput, {
          "data-test-id": `${appName}-form-file-input`,
          name: property.name,
          onChange: () => onChange({
            key: property.name,
            value: '',
            required: property.required || false
          }),
          disabled: disabled
        })
      });
    case propertyFieldTypes.textarea:
      return /*#__PURE__*/_jsx(UIInputWrapper, {
        property: property,
        editMode: editMode,
        ariaLabel: "form-text-area",
        children: /*#__PURE__*/_jsx(TextArea, {
          inputRef: inputRef,
          "data-test-id": `${appName}-form-text-area`,
          name: property.name,
          onChange: event => onChange({
            key: property.name,
            value: event.target.value,
            required: property.required || false
          }),
          value: currentValue,
          disabled: disabled
        })
      });
    default:
      return /*#__PURE__*/_jsx(UIInputWrapper, {
        property: property,
        editMode: editMode,
        ariaLabel: "form-text-input",
        children: /*#__PURE__*/_jsx(TextInput, {
          inputRef: inputRef,
          autoCorrect: "off",
          autoCapitalize: "none",
          "data-test-id": `${appName}-form-text-input${property.fieldType === propertyFieldTypes.email ? '-email' : ''}`,
          type: matchPropertyTypeToInput[property.fieldType],
          name: property.name,
          onChange: event => onChange({
            key: property.name,
            value: event.target.value,
            required: property.required || false
          }),
          value: currentValue,
          disabled: disabled
        })
      });
  }
};
export default FormInput;